import { MemberProfile } from './member-profile';
import { MembershipAddress } from './membership-address';

export interface MemberSummary {
    wonCount: number;
    lostCount: number;
    sellingCount: number;
    soldCount: number;
    unsoldCount: number;
    positiveFeedback: number;
    negativeFeedback: number;
    totalFeedback: number;
    memberId: number;
    nickname: string;
    dateJoined: Date;
    dateAddressVerified: Date;
    isAddressVerified: boolean;
    balance: number;
    firstName: string;
    lastName: string;
    email: string;
    gender: number;
    membershipAddress: MembershipAddress;
    isBusiness: boolean;
    closestLocality: string;
    closestDistrict: string;
    closestDistrictId: number;
    isAuthenticated: boolean;
    favouriteSearchCount: number;
    favouriteCategoryCount: number;
    favouriteSellerCount: number;
    recentSearchesEnabled: boolean;
    highVolumeListingCount: number;
    highVolumeThreshold: number;
    canRemoveBids: boolean;
    canUseShoppingCart: boolean;
    shoppingCartCount: number;
    externalTrackingToken: string;
    landlinePhoneNumber: string;
    mobilePhoneNumber: string;
    memberToken: string;
    memberProfile: MemberProfile;
    isPropertyAgent: boolean;
    isJobAgent: boolean;
}
